export interface CompanyInfo {
  id: number;
  name: string;
  credit: string;
  finance_mail: string;
  created_at: string;
  pib: string;
  company_id: string;
  real_name: string;
  airport_transfer: number;
  active: number;
  credit_low_limit: string;
  company_type: string;
  address: string;
  date_created: string;
  image: string;
  is_special?: boolean | number;
}

export interface CompanyData {
  ridesToday: number;
  expenseToday: number;
  ridesTotal: number;
  expenseTotal: string;
  is_new: boolean;
  company: CompanyInfo;
}

export function isSpecialCompany(companyData: CompanyData | null | undefined): boolean {
  const value = companyData?.company?.is_special;
  return value === true || value === 1;
}

